import React, {useState} from 'react';
import {Divider} from "primereact/divider";
import CmpInputArea from "../components/CmpInputArea";
import CmpDataViewArea from "../components/CmpDataViewArea";
import {Image} from "primereact/image";
import {LineShareButton, TwitterShareButton, LineIcon, TwitterIcon} from "react-share";
import GoogleAds from 'react-google-ads'

const PageHome = () => {
    const [videos, setVideos] = useState({})

    return (
        <div>
            <div className={"field"}>
                <h1>Youtube Data Collector：FREE</h1>
                <Image src={'./youtube_data_collector_logo.png'} width={"480"}/>
            </div>
            <Divider/>
            <h2>使い方</h2>
            <div className={"flex justify-content-center align-items-left text-left"}>
                <ul>
                    <li>GoogleCloudPlatformからAPI Keyを取得する 参考：<a
                        href={"https://blog.codecamp.jp/programming-api-youtube"} target={"_blank"}
                        rel="noreferrer">URL</a></li>
                    <li>取得したAPI KeyとチャンネルIDを入力する</li>
                    <li>Submitボタンをクリックする。</li>
                    <li><font color={"red"}>API
                        Keyに関しては、ログなど一切取っていないので問い合わせいただいてもお答えすることができません。</font>
                    </li>
                </ul>
            </div>
            <div className={"row"}>
                <LineShareButton url={"https://ytdc.snuow.com/"} title={"YoutubeDataCollector"}>
                    <LineIcon size={40} round={true}/>
                </LineShareButton>
                <TwitterShareButton url={"https://ytdc.snuow.com/"} title={"YoutubeDataCollector"} via={"snuow_w"}
                                    hashtag={['youtube', 'Webアプリ']}>
                    <TwitterIcon size={40} round={true}/>
                </TwitterShareButton>
            </div>

            <CmpInputArea setVideos={setVideos}/>
            <Divider/>
            <div className={"grid"}>
                {(() => {
                    if (Object.keys(videos).length === 0) {
                        return <div></div>
                    } else {
                        return (
                            <div className={"col-10 col-offset-1"}>
                                <CmpDataViewArea videos={videos}/>
                            </div>
                        )
                    }
                })()}
            </div>
            <GoogleAds
                client="ca-pub-7564951138501561"
                slot="2413220047"
                className="adsbygoogle"
                format="auto"
                style={{display: 'block'}}
            />
        </div>
    )
}

export default PageHome